import { useState, useEffect, useMemo, useCallback } from "react";
import { isAllBlanksFilled } from "../../../utils/quiz-parser.js";
function useSelectTextQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  const [answers, setAnswers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const canSubmit = isAllBlanksFilled(answers);
  const shouldShowCorrectAnswers = showReallyTrue || isShowingCorrectAnswers;
  useEffect(() => {
    onAnswerChange == null ? void 0 : onAnswerChange(answers);
  }, [answers, onAnswerChange]);
  const selectData = useMemo(() => {
    const reg = /\{\{(.*?)}}/gim;
    const contents = [];
    let match;
    while ((match = reg.exec(quiz.problem)) !== null) {
      contents.push(match[1]);
    }
    return contents;
  }, [quiz.problem]);
  const selectCount = selectData.length;
  const problemKey = useMemo(
    () => `${quizId}-${selectCount}-${quiz.problem.length}`,
    [quizId, selectCount, quiz.problem]
  );
  useEffect(() => {
    if (initialAnswersProp && initialAnswersProp.length > 0) {
      setAnswers(initialAnswersProp);
    } else if (isViewSolved && (solveResult == null ? void 0 : solveResult.correctAnswers)) {
      setAnswers(solveResult.correctAnswers.map((a) => String(a)));
    } else {
      setAnswers(new Array(selectCount).fill(""));
    }
    setCurrentIndex(0);
  }, [quiz.problem, isViewSolved, solveResult == null ? void 0 : solveResult.correctAnswers, initialAnswersProp, selectCount]);
  const handleToggleDropdown = useCallback((index) => {
    if (isSolved || isViewSolved) return;
    setOpenDropdown((prev) => prev === index ? null : index);
    setCurrentIndex(index);
  }, [isSolved, isViewSolved]);
  const handleSelect = useCallback((selectIndex, optionIndex) => {
    if (isSolved || isViewSolved) return;
    setAnswers((prev) => {
      const newAnswers = [...prev];
      newAnswers[selectIndex] = optionIndex.toString();
      return newAnswers;
    });
    setOpenDropdown(null);
    if (selectIndex < selectCount - 1) {
      setCurrentIndex(selectIndex + 1);
    }
  }, [isSolved, isViewSolved, selectCount]);
  const handleSubmit = useCallback(() => {
    if (!canSubmit || isSolved) return;
    const elapsedTime = Date.now() - startTime;
    onSolve == null ? void 0 : onSolve(quizId, answers, quiz.vars, elapsedTime);
  }, [answers, canSubmit, isSolved, onSolve, quizId, quiz.vars, startTime]);
  useEffect(() => {
    const handleClickOutside = () => {
      if (openDropdown !== null) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [openDropdown]);
  return {
    answers,
    currentIndex,
    openDropdown,
    selectData,
    selectCount,
    problemKey,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleToggleDropdown,
    handleSelect,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useSelectTextQuiz
};
//# sourceMappingURL=use-select-text-quiz.js.map
